import { ActionTypes } from "../constants/action-types";

const initialState = {
  price_filter_clear: false,
};

export const priceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.PRICE_FILTER:
      return {
        ...state,
        price_filter_clear: payload,
      };
    default:
      return state;
  }
};
